import { render, staticRenderFns } from "./AssignValues.vue?vue&type=template&id=f645a9b8&scoped=true"
import script from "./AssignValues.vue?vue&type=script&lang=js"
export * from "./AssignValues.vue?vue&type=script&lang=js"
import style0 from "./AssignValues.vue?vue&type=style&index=0&id=f645a9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f645a9b8",
  null
  
)

export default component.exports